module.exports = __webpack_public_path__ + "static/honda-type-r-front-grill-white-allstocksociety-600px-75de3146baeefd2bffccc394347ba2ba.jpg";